module.exports = __webpack_public_path__ + "img/banner-regalos.b9c0f07e.png";